import { dscvrApi } from '@/shared/api';

export const useUnlinkMatricaWalletMutation = async () => {
  return dscvrApi.matrica.unlinkMatricaWallet();
};
